var React = require('react');

function ContinueIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.884 13a.634.634 0 01-.43-.166.563.563 0 01-.012-.825L6.52 7.06 1.18 1.996a.563.563 0 010-.825.64.64 0 01.87 0l5.77 5.47c.238.226.24.59.006.82l-5.5 5.363a.638.638 0 01-.442.176z","fill":"#FFF","fillRule":"nonzero","stroke":"#FFF","strokeWidth":".923"}));
}

ContinueIconInline.defaultProps = {"width":"9","height":"14"};

module.exports = ContinueIconInline;

ContinueIconInline.default = ContinueIconInline;
